import React  from 'react';
import {  Card, CardBody, CardHeader, Row, Col, Table } from "reactstrap";
import { Spinner } from 'components/Icons/Spinner';

var Utils = require ('Utils') ;
var Const = require ('Const') ;

export const Birthdays = ( { personas  } ) =>  {
    let hoy = new Date();
        return (
          
          <>
          
          {personas ?
          
              <Card >
                  <CardHeader>
                    Cumpleaños en estos días
                  </CardHeader>
                <CardBody>
                  <Row>
                      <Col sm="12">
                      <Table responsive bordered striped size="sm">
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Fecha</th>
                                    <th>Foto</th>
                                    <th>Curso</th>
                                </tr>
                            </thead>
                        <tbody>
                            { personas.map( ( persona ) => { 
                              let dia = new Date(persona.birthdate.replace('Z',''));
                              let esHoy = dia.getDate()===hoy.getDate() && dia.getMonth()===hoy.getMonth();
                            return (
                                <>
                                <tr key={persona.persona_id} style={{fontWeight: (esHoy ?'800':'')}}>
                                    <td>{Utils.capitalize(persona.name + " " + persona.last_name) + (esHoy?" 🎁":"")}</td>
                                    <td >{dia.getDate() + " de " + Const.MONTHS[dia.getMonth()] }</td>
                                    <td>{persona.image&&
                                      <img src={persona.image} alt={persona.last_name} 
                                          style={{width: '100px', borderRadius: '4px'}}
                                      />
                                    }
                                    </td>
                                    <td>{persona.course_name}
                                    </td>
                                </tr>
                                </> 
                                )
                            } ) }
                        </tbody>
                      </Table>
                      </Col>
                  </Row>
                </CardBody>
              </Card>
          :
          <Spinner size="XL" />
          }
        </>
  
        );
        }
